/** @jsx jsx */

import { Global } from '@emotion/react';
import { Box, jsx } from 'theme-ui';

import Helmet from 'react-helmet';

import Footer from '@/components/Footer';
import Nav from '@/components/Nav';

// const Layout: FC = ({ children }) => (
interface LayoutProps {
  children: any;
}

function Layout({ children }: LayoutProps) {
  return (
    // <Box>
    <Box
      sx={{
        display: `flex`,
        flexDirection: `column`,
        // set this to `minHeight: '100vh'` for full viewport height
        minHeight: `80vh`,
      }}
    >
      <Helmet>
        <link rel="stylesheet" href="https://use.typekit.net/qsb2yvc.css" />
      </Helmet>
      <Global
        styles={(theme: any) => `
          ::selection {
            background-color: ${theme.colors.background};
          }
          
          :focus {
            outline: 0px double ${theme.colors.action};
            outline-offset: 0.125em;
          }
          
          body {
            background: ${theme.colors.base};
            margin: 0;
          }
          a {
            text-decoration: none;
            color: ${theme.colors.primary};
          }
      `}
      />
      <Box
        as="header"
        sx={{
          width: `100%`,
        }}
      >
        <Nav />
      </Box>
      <Box
        as="main"
        sx={{
          width: `100%`,
          flex: `1 1 auto`,
        }}
      >
        {children}
      </Box>
      <Box
        as="footer"
        sx={{
          width: `100%`,
        }}
      >
        <Footer />
      </Box>
    </Box>
  );
}
export default Layout;
